import axios from 'axios';
import { AdminDashboardStatsResponse } from '../types/admin-management';

export class AdminDashboardService {
  /**
   * 管理者ダッシュボード統計データを取得
   */
  async getDashboardStats(): Promise<AdminDashboardStatsResponse> {
    try {
      const response = await axios.get('/api/admin/dashboard/stats', {
        withCredentials: true, // Cookie認証用
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorMessage =
          error.response?.data?.error?.message ||
          'ダッシュボード統計の取得に失敗しました';
        throw new Error(errorMessage);
      }
      throw new Error('ダッシュボード統計の取得に失敗しました');
    }
  }
}

export const adminDashboardService = new AdminDashboardService();
